import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { insights } from "./bulletsData";

const BulletsSection = () => {
  return (
    <Container className="py-5">
      <Row className="mt-4">
        <Col>
          <h5 className="text-center number-heading text-lg" style={{textTransform: 'capitalize'}}>
            <span className="text-blue ">
            AI Native solution for efficient and effective
            </span>
            <span className="text-light-blue">
            {" "}  test planning and execution
            </span>
          </h5>
        </Col>
      </Row>
      <Row>
        <Col>
          <p className="text-center text-grey">
          Something to gain for everyone from GAINSS
          </p>
        </Col>
      </Row>
      <Row className="mt-4">
        {insights.map((insight) => (
          <Col md="4" sm="12" key={insight.role}>
            <div className="text-center">
              <img src={insight.icon} alt={insight.role} />
            </div>
            <h6 className="text-center mt-4">{insight.role}</h6>
            <ul className="flex-wrap mt-4">
              {insight.points.map((feature, index) => (
                <li
                  as="li"
                  key={index}
                  className="p-1 border-0 me-3 text-606060"
                  style={{ fontSize: '16px' }}
                >
                  {feature}
                </li>
              ))}
            </ul>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default BulletsSection;
